.mediaViewDialog {
  max-width: 90vw !important;
  width: 90vw !important;
  height: 90vh;
}

.mediaViewDialogBody {
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.mediaViewDialogBody div:has(> :global(.item)) {
  margin-bottom: 10px;
}